<template>
  <v-app>
    <core-app-bar />
    <core-drawer />
    <core-stripe-payment-view />
    <core-footer />
  </v-app>
</template>

<script>
export default {
  name: 'StripePayment',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreStripePaymentView: () => import('../components/core/StripePaymentView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
